import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { AuthProvider } from "./contexts/AuthContext"
import { UIProvider } from "./contexts/UIContext"
import { NotificationProvider } from "./contexts/NotificationContext"
import "./index.css"
import { debugEnvironmentVariables } from "./utils/debug-env"

// Debug environment variables in development
if (process.env.NODE_ENV !== 'production') {
  debugEnvironmentVariables();
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <NotificationProvider>
        <AuthProvider>
          <UIProvider>
            <App />
          </UIProvider>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  </React.StrictMode>
);

